export interface UndoRedoConfig {
    undoableTypes: Record<string, string>
    nonUndoableKeys: Record<string, Record<string, string>>
    nogoNamespaces: string[]
}

export type SupportedFragments = Record<string, {loadOnInit: boolean; singletonInstance?: string}>

export interface BaseDSConfig {
    configName?: string
    modulesList: string[]
    extensionsList: string[]
    supportedFragments?: SupportedFragments
    disableFragments?: boolean
    isReadOnly: boolean
    noUndo: boolean
    runStylesGC: boolean
    supportMobile: boolean
    supportsPlatformInitialization: boolean
    transactionActionsLimit: number
    csaveSnapshotActionsLimit: number
    csaveTransactionsLimit: number
    isDebugMode?: boolean
    postUpdateOperation?: boolean
    closeSectionGaps?: boolean
    loadsMiniSiteManager?: boolean
    selectiveCompsDS?: boolean
    supportsUsingPresetVariants?: boolean
    useResourceLoaderForInit?: boolean
    disableMobileConversion?: boolean
    disableSave?: boolean
    disableCSaveValidationOnInitialization?: boolean
    disableAutoSave?: boolean
    /** whether csave is on */
    continuousSave?: boolean
    /** whether createRevision is on */
    createRevision?: boolean
    /** whether concurrent editing is on */
    cedit?: boolean
    acceptTransactionsFromDuplexer?: boolean
    /** autosave restore mode */
    autosaveRestore?: string
    /** immutable domain mode */
    immutableDomain?: boolean
    /** message distribution through duplexer*/
    concurrentWorkEnabled?: boolean
    origin: string
    initialSeed?: boolean | string
    disableCommonConfig: boolean
    documentDataFixer?: string
    /** Support runtime override of component's schemas */
    schemaDevMode?: boolean
    signatureSeed?: string
    undoRedoConfig?: UndoRedoConfig
    untilTransactionId?: string
    dontCollectFixerVersionData?: boolean
    keepMultiLingualModelsFromServer?: boolean
    lazyLoadPages: boolean
    enableScopes?: boolean
    enableRepeatersInScopes?: boolean
    enableRefComponentFallbackToViewerManager?: boolean
    doNotSyncRepeatedLayout?: boolean
    minNumOfPagesToCalculateRenderHints: number
    showMobileView?: boolean
    shouldSquashTransactions?: boolean
    skipFixers?: boolean
    skipDataMigrators?: boolean
    editorType?: string
    localEditor?: boolean
    localEditorWsUrl?: string
    excludeRevoking?: boolean
    disablePublishPipeline?: boolean
    enableWidgetInRepeater?: boolean
    shouldUseMobileLibrary?: boolean
    withoutViewer?: boolean
    skipBuilderSchemaValidation?: boolean
    enforceStrictValidationEverywhere?: boolean
    enforceNoWhitelistDalStrictSchemaValidation?: boolean
    loadingPartialPages?: boolean
    strictBlacklistBaselineForEmployees?: boolean
}

export interface ExperimentalConfig extends Partial<Pick<BaseDSConfig, 'modulesList' | 'extensionsList'>> {
    configOptions: Partial<Omit<BaseDSConfig, 'modulesList' | 'extensionsList'>>
}

export interface DSConfig extends BaseDSConfig {
    experimentalConfigOptions?: Record<string, ExperimentalConfig>
}
